(() => {
  const STORAGE_KEY = 'ninja-language-preference-v1';

  function isThemePreview() {
    const params = new URLSearchParams(window.location.search);
    return params.has('preview_theme_id') ||
      params.has('_fd') ||
      Boolean(window.Shopify && window.Shopify.designMode);
  }

  function normalizeLocale(locale) {
    return String(locale || '').trim().toLowerCase().replace('_', '-');
  }

  function bindSelector(select) {
    if (select.dataset.ninjaLocaleReady === 'true') return;
    select.dataset.ninjaLocaleReady = 'true';
    select.addEventListener('change', () => {
      try {
        window.localStorage.setItem(STORAGE_KEY, select.value);
      } catch (_) {}
    });
  }

  function initialize() {
    const selectors = Array.from(document.querySelectorAll('select[name="language_code"]'));
    if (!selectors.length) return;

    selectors.forEach(bindSelector);

    // Shopify's draft preview depends on preview_theme_id. Submitting the
    // localization form removes it and makes the preview appear broken.
    // Keep the manual language selector active, but never auto-redirect previews.
    if (isThemePreview()) return;

    let storedPreference = '';
    try {
      storedPreference = window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (_) {}
    if (storedPreference) return;

    const available = Array.from(selectors[0].options).map(option => option.value);
    const browserLocales = Array.isArray(navigator.languages) && navigator.languages.length
      ? navigator.languages
      : [navigator.language];

    let preferred = '';
    for (const browserLocale of browserLocales) {
      const normalized = normalizeLocale(browserLocale);
      preferred = available.find(code => normalizeLocale(code) === normalized) ||
        available.find(code => normalized.startsWith(normalizeLocale(code) + '-')) ||
        available.find(code => normalizeLocale(code).startsWith(normalized + '-')) ||
        '';
      if (preferred) break;
    }

    if (!preferred || preferred === selectors[0].value) return;

    try {
      window.localStorage.setItem(STORAGE_KEY, preferred);
    } catch (_) {}

    selectors[0].value = preferred;
    selectors[0].dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();